(ns manage.ad-variant.creation.strategy.hooks
  (:require [cljs-bean.core :refer [->clj]]
            [common.queries :refer [use-suspense-query use-suspense-queries use-mutation]]
            [common.resource.query.adset :as adset-queries]
            [manage.ad-variant.creation.feed.mapping.util :refer [strategy-class]]
            [manage.content-variant-page.queries :as content-queries]
            [mate.core :as mc]
            [uix.core :as uix :refer [defhook]]
            [uix.re-frame :refer [use-subscribe]]))

(defn combine-queries [^js results]
  (let [[{feed-columns :data}
         {{{:keys [field-classes field-formats]} :data} :data}] (->clj results)
        column->classes (update-vals (group-by :name field-classes)
                                     (fn [classes] (set (map :class classes))))
        column->format (mc/index-by :name field-formats)
        columns (reduce
                 (fn [columns column]
                   (let [column-classes (get column->classes column)
                         {:keys [multi delimiter]} (get-in column->format [column :format])
                         is-strategy (contains? column-classes strategy-class)
                         is-unclassified (nil? column-classes)
                         column-data (when (or is-unclassified is-strategy)
                                       (cond-> {:selected is-strategy}
                                         multi (assoc :multi-value multi
                                                      :delimiter delimiter)))]
                     (cond-> columns
                       (some? column-data) (assoc column column-data))))
                 {}
                 feed-columns)]
    #js {:column->classes column->classes
         :column->format column->format
         :columns columns
         :selected-separator (or (some (comp :delimiter val) columns) ",")
         :is-all-selected (every? (comp :selected val) columns)
         :is-any-multi-value (some (comp :multi-value val) columns)}))

(defhook use-be-state []
  (let [{:keys [advertiser-id adset-id]} (use-subscribe [:url-context])

        {{feed-id :feedId} :data}
        (use-suspense-query (adset-queries/adset-query {:adset-id adset-id}))

        combined-result
        (use-suspense-queries
         #js {:queries #js [(content-queries/get-fields advertiser-id feed-id)
                            (content-queries/get-content-feed advertiser-id feed-id)]
              :combine combine-queries})

        {update-classes :mutate}
        (use-mutation (content-queries/update-field-classes-mutation advertiser-id feed-id))

        {update-formats :mutate}
        (use-mutation (content-queries/update-field-formats-mutation advertiser-id feed-id))]
    (assoc combined-result :update-classes update-classes :update-formats update-formats)))

(defn ->be-column-classes [column->classes]
  (mapcat (fn [[column classes]]
            (map (fn [class] {:name column :class class}) classes))
          column->classes))

(defhook use-select-all-controls []
  (let [{:keys [is-all-selected update-classes columns column->classes]} (use-be-state)]
    {:set-all-selection (uix/use-callback
                         (fn [value]
                           (update-classes
                            (->be-column-classes
                             (reduce (fn [column->classes [column]]
                                       (if value
                                         (assoc column->classes column #{strategy-class})
                                         (dissoc column->classes column)))
                                     column->classes
                                     columns))))
                         [columns column->classes update-classes])
     :is-all-selected is-all-selected}))

(defhook use-select-single-controls []
  (let [{:keys [update-classes columns column->classes]} (use-be-state)]
    {:toggle-column-selection (uix/use-callback
                               (fn [column]
                                 (update-classes
                                  (->be-column-classes
                                   (if (get-in columns [column :selected])
                                     (dissoc column->classes column)
                                     (assoc column->classes column #{strategy-class})))))
                               [columns column->classes update-classes])
     :columns columns}))

(defhook use-separator-controls []
  (let [{:keys [selected-separator update-formats columns column->format is-any-multi-value]}
        (use-be-state)]
    {:is-any-multi-value is-any-multi-value
     :selected-separator selected-separator
     :set-selected-separator (uix/use-callback
                              (fn [value]
                                (update-formats
                                 (->> columns
                                      (reduce
                                       (fn [column->format [column {:keys [multi-value]}]]
                                         (cond-> column->format
                                           multi-value (assoc-in [column :format :delimiter]
                                                                 value)))
                                       column->format)
                                      vals
                                      vec)))
                              [columns column->format update-formats])}))

(defhook use-multi-value-controls []
  (let [{:keys [selected-separator update-formats columns column->format]} (use-be-state)]
    {:columns columns
     :toggle-multi-value (uix/use-callback
                          (fn [column]
                            (update-formats
                             (vec
                              (vals
                               (if (get-in columns [column :multi-value])
                                 (dissoc column->format column)
                                 (assoc column->format column
                                        {:name column
                                         :format {:multi true
                                                  :delimiter selected-separator}}))))))
                          [columns column->format update-formats selected-separator])}))

(defhook use-search-state []
  (let [[search-term set-search-term] (uix/use-state "")]
    {:search-term search-term
     :matches-search-term? (uix/use-callback
                            (fn [column]
                              (or (empty? search-term)
                                  (.includes (.toLowerCase column)
                                             (.toLowerCase search-term))))
                            [search-term])
     :set-search-term set-search-term}))
